<app-flow-page-layout [scrollMode]="'route-shell'" [contentScrollOwner]="'nested'">
  <app-page-header header [config]="headerConfig()" />

  <div class="investment-create">
    <app-form-page-shell
      [initialLoading]="isLoading() && !formConfig()"
      [refreshing]="isLoading() && !!formConfig()"
      [ready]="!!formConfig()"
    >
      <app-form-wizard-enhanced
        #formWizard
        [config]="formConfig()"
        [initialData]="initialData()"
        [mode]="'create'"
        [showValidationSummary]="true"
        (cancel)="onCancel()"
        (formChange)="onFormChange($event)"
      />
    </app-form-page-shell>
  </div>
</app-flow-page-layout>

<app-investment-location-input-modal
  [visible]="facade.locationModalVisible()"
  [initialData]="facade.locationData()"
  [saving]="facade.isSavingLocationModal()"
  (visibleChange)="facade.setLocationModalVisible($event)"
  (hidden)="facade.onLocationModalHidden()"
  (saveRequested)="onLocationSave($event)"
/>
